import React from 'react';
import validatedComponent from '../common/ValidatedComponent.jsx';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import * as Actions from './redux/actions.changeEmail';
import ImageUtils from '../utils/ImageUtils';

class EmailVerify extends React.Component {
  onVerifyClick(e) {
    e.preventDefault();
    const {id, token} = this.props.params;
    this.props.verifyEmail(id, token);
  }

  render() {
    return (
      <div className="email_verify">
        <div className="email_verify_header">
          <img className="email_verify_header_logo"
               src={ImageUtils.getAppLogoUrl()}
               alt="logo"/>
        </div>
        <div className="email_verify_card">
          <h2>Click here to verify email</h2>
          <button href="#" onClick={this.onVerifyClick.bind(this)}>Verify</button>
        </div>
      </div>);
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

EmailVerify.displayName = 'EmailVerify';

export default connect(null, mapDispatchToProps)(validatedComponent(EmailVerify));




// WEBPACK FOOTER //
// ./shared/profile/ConfirmEmail.jsx